import type { Action } from 'redux';

import normaliseError, { type NormaliseErrorInput } from '/shared/functions/normaliseError';
import type { NormalisedError } from '/index';
import type { ModalValue } from '/shared/state/actions/modal';

export interface ModalState {
  modal: ModalValue | null;
  error: NormalisedError | null;
}

interface ShowModalStartedAction extends Action {
  type: 'SHOW_MODAL_STARTED';
}

interface ShowModalFulfilledAction extends Action {
  type: 'SHOW_MODAL_FULFILLED';
  modal: ModalValue;
}

interface ShowModalRejectedAction extends Action {
  type: 'SHOW_MODAL_REJECTED';
  error: NormaliseErrorInput;
}

interface CloseModalStartedAction extends Action {
  type: 'CLOSE_MODAL_STARTED';
}

interface CloseModalFulfilledAction extends Action {
  type: 'CLOSE_MODAL_FULFILLED';
}

interface CloseModalRejectedAction extends Action {
  type: 'CLOSE_MODAL_REJECTED';
  error: NormaliseErrorInput;
}

type ModalAction =
  | ShowModalStartedAction
  | ShowModalFulfilledAction
  | ShowModalRejectedAction
  | CloseModalStartedAction
  | CloseModalFulfilledAction
  | CloseModalRejectedAction;

const defaultState: ModalState = {
  modal: null,
  error: null,
};

function reducer(state: ModalState = defaultState, action: ModalAction): ModalState {
  switch (action.type) {
    case 'SHOW_MODAL_STARTED': {
      return {
        ...state,
        error: null,
      };
    }
    case 'SHOW_MODAL_FULFILLED': {
      return {
        ...state,
        modal: action.modal,
      };
    }
    case 'SHOW_MODAL_REJECTED': {
      return {
        ...state,
        error: normaliseError(action.error),
      };
    }
    case 'CLOSE_MODAL_STARTED':
      return {
        ...state,
        error: null,
      };
    case 'CLOSE_MODAL_FULFILLED': {
      return defaultState;
    }
    case 'CLOSE_MODAL_REJECTED': {
      return {
        ...state,
        error: normaliseError(action.error),
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
